import React from 'react';
import { Dialog, DialogContent, DialogContentText, DialogTitle, Grid, IconButton, Typography, useMediaQuery, useTheme } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import CommonForm from 'components/commonForm/CommonForm';

export default function CommonDialog(props) {
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down('md'));
  const handleClose = () => {
    props.handleClose();
  };
  return (
    <div>
      <Dialog
        fullScreen={fullScreen}
        open={props.open}
        onClose={handleClose}
        aria-labelledby="responsive-dialog-title"
      >
        <DialogTitle id="responsive-dialog-title" className='modelMain'>
          <IconButton
            aria-label="close"
            onClick={handleClose}
            className="modelCloseIcon"
          >
            <CloseIcon />
          </IconButton>
          <Grid container>
            <Grid item xs={12} className="dialogHead">
              {props.selectType === 'Send' ? (
                <Typography>
                  {props.selectType === 'Send' ? props.type : ''}
                </Typography>
              ) : props.selectType === 'edit' ? (
                <Typography className="titleStyle">
                  {props?.type?.split(' ').slice(0, 1)}{' '}
                  <span className="colorSecondary">
                    {props?.type?.split(' ').slice(1).join(' ')}
                  </span>
                </Typography>
              ) : props.selectType === 'Create' ? (
                <Typography className="titleStyle">
                  {'Add '}
                  <span className="colorSecondary">{props.type}</span>
                </Typography>
              ) : props.selectType === 'vendorAdd' ? (
                <Typography className="titleStyle">
                  {'Enter '} {props.type}
                  <span className="colorSecondary">{' Details'}</span>
                </Typography>
              ): null}
            </Grid>
          </Grid>
        </DialogTitle>
        <DialogContent>
          <DialogContentText>
            <Grid container>
              <Grid item xs={12} className="formPadding">
                <CommonForm
                  formData={props.formData}
                  button={props.button}
                  onSubmittBtn={props.onSubmittBtn}
                  selectType={props.selectType}
                  handleClose={handleClose}
                  type={props.type}
                  defaultValues={props?.defaultValues}
                  optionData={props?.optionData}
                  onImageHandleChange={props?.onImageHandleChange}
                />
              </Grid>
            </Grid>
          </DialogContentText>

        </DialogContent>
      </Dialog>
    </div>
  );
}
